module.exports = {"title":"Impressum","body":"<p>Legal</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./impressum.md
// module id = 1187
// module chunks = 0